import { AuthorityType } from '../../model/user/authority-type.enum';
import { HeaderDropdownMenu } from './header-dropdown-menu';
import { HeaderMenu } from './header-menu';
import { Injectable } from '@angular/core';
import { isUndefined } from 'util';
import { NecLocalStorageService } from '../../service/localStorage/local-storage.service';
import { Subject } from 'rxjs';

/**
 * æä¾æ´æ°Headerä¸­ä¿¡æ¯çæ¹æ³
 */
@Injectable()
export class HeaderService {
  private updateInfoSource = new Subject();
  private updateActiveModuleSource = new Subject<string>();
  updateInfo$ = this.updateInfoSource.asObservable();
  updateActiveModule$ = this.updateActiveModuleSource.asObservable();

  /**
   * è®°å½æ¯å¦æ¯å»çäºåå¯ç»å½
   */
  isHCloudLogin = false;
  /**
   * è®°å½å»çäºåå¯ç»å½çåæ°
   * {userKey:'', authUrl: ''}
   */
  hCloudLoginParam: any;

  constructor(private ls: NecLocalStorageService) {
    this.hCloudLoginParam = ls.get('kyHCloudLoginParam');
    this.isHCloudLogin = !!(this.hCloudLoginParam && this.hCloudLoginParam.userKey);
  }

  /**
   * æ´æ°ç¨æ·ä¿¡æ¯ï¼æ¯å¦ç¨æ·å/ç»å½ç¶æ/ä¸ªäººå¤´åå¾ç/logoå¾çç­ï¼
   */
  updateInfo() {
    this.updateInfoSource.next('update');
  }

  /**
   * æ´æ°moduleçactiveç¶æ
   */
  updateActiveModule(module: string) {
    this.updateActiveModuleSource.next(module);
  }

  /**
   * è®¡ç®menusä¸­åä¸ªèåæç»æ¯æ¾ç¤ºè¿æ¯éè
   */
  calcMenuShowOrNot(menus: HeaderMenu[] | HeaderDropdownMenu[], role: AuthorityType, isCertified: boolean) {
    if (!menus) {
      return menus;
    }

    for (let menu of menus) {
      if (menu.text === 'èº«ä»½è®¤è¯') {
        if (!isUndefined(menu.show)) {
          continue;
        }
      }
      if (!isUndefined(menu.onlyShowWhen) && menu.onlyShowWhen.indexOf(role) < 0) {
        menu.show = false;
      }
      else if (!isUndefined(menu.needCeritfied) && !isCertified) {
        menu.show = false;
      }
      else {
        menu.show = true;
        if (menu.text === 'èº«ä»½è®¤è¯') {
          menu.show = !this.isHCloudLogin;
        }
      }
    }
  }
}
